"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComparisonBarItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _useTooltip = require("b2b-components/hooks/useTooltip");
var _Icon = require("b2b-components/theme/components/Icon");
var _device = require("b2b-components/utils/device");
var _classnames = _interopRequireDefault(require("classnames"));
require("./ComparisonBarItem.scss");
const ComparisonBarItem = _ref => {
  let {
    item,
    onClick,
    onRemove,
    isListItem = true,
    className,
    tooltipClassName,
    deviceType
  } = _ref;
  const Element = isListItem ? 'li' : 'div';
  const {
    tooltipAnchorRef,
    tooltipRef,
    tooltipPosition,
    isTooltipVisible,
    onMouseEnter,
    onMouseLeave
  } = (0, _useTooltip.useTooltip)({
    isPositionFixed: true
  });
  const handleImageLoadError = event => {
    event.currentTarget.style.fontSize = '0';
  };
  const Tooltip = () => /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("div", {
    style: {
      ...(tooltipPosition.top && {
        top: tooltipPosition.top
      }),
      ...(tooltipPosition.left && {
        left: tooltipPosition.left
      })
    },
    className: (0, _classnames.default)('cds-ComparisonBarItem-Tooltip', tooltipClassName),
    ref: tooltipRef
  }, item.name), document.body);
  return /*#__PURE__*/_react.default.createElement(Element, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    className: (0, _classnames.default)('cds-ComparisonBarItem', {
      'cds-ComparisonBarItem--Highlighted': isTooltipVisible,
      'cds-ComparisonBarItem--Mobile': (0, _device.isMobile)(deviceType)
    }, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-ComparisonBarItem-Content",
    ref: tooltipAnchorRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-ComparisonBarItem-ImageBox",
    onClick: () => onClick(item.id)
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: item.thumbnail,
    alt: item.name,
    className: "cds-ComparisonBarItem-Image",
    onError: handleImageLoadError
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-ComparisonBarItem-Remove",
    onClick: () => onRemove(item.id)
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.alertError,
    size: _Icon.ICON_SIZE.small,
    className: "cds-ComparisonBarItem-RemoveIcon"
  }))), isTooltipVisible && /*#__PURE__*/_react.default.createElement(Tooltip, null));
};
exports.ComparisonBarItem = ComparisonBarItem;
//# sourceMappingURL=ComparisonBarItem.js.map